import React, { useState } from 'react';
import educations from '../../assets/education.json';
import experiences from '../../assets/experience.json';
import './qualification.css';

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);
    const [showExperience, setShowExperience] = useState(false);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const renderTimeline = (data) =>
        data.map((item, i) => (
            <div className="qualification__data" key={i}>
                {i % 2 === 0 ? (
                    <>
                        <div className="qualification__data-left">
                            <h3 className="qualification__title">{item.title}</h3>
                            <span className="qualification__subtitle">{item.subtitle}</span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt"></i> {item.date}
                            </div>
                            {item.details && <p>{item.details}</p>}
                        </div>
                        <div className="qualification__data-center">
                            <span className="qualification__rounder"></span>
                            {i !== data.length - 1 && <span className="qualification__line"></span>}
                        </div>
                        <div className="qualification__data-right"></div>
                    </>
                ) : (
                    <>
                        <div className="qualification__data-left"></div>
                        <div className="qualification__data-center">
                            <span className="qualification__rounder"></span>
                            {i !== data.length - 1 && <span className="qualification__line"></span>}
                        </div>
                        <div className="qualification__data-right">
                            <h3 className="qualification__title">{item.title}</h3>
                            <span className="qualification__subtitle">{item.subtitle}</span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt"></i> {item.date}
                            </div>
                            {item.details && <p>{item.details}</p>}
                        </div>
                    </>
                )}
            </div>
        ));

    return (
        <section className="qualification section" id="portfolio">
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My personal journey</span>

            <div className="qualification__container container">
                <div className="qualification__tabs">
                    <div
                        className={
                            toggleState === 1
                                ? 'qualification__button qualification__active button--flex'
                                : 'qualification__button button--flex'
                        }
                        onClick={() => toggleTab(1)}
                    >
                        <i className="uil uil-graduation-cap qualification__icon"></i> Education
                    </div>

                    {showExperience && (
                        <div
                            className={
                                toggleState === 2
                                    ? 'qualification__button qualification__active button--flex'
                                    : 'qualification__button button--flex'
                            }
                            onClick={() => toggleTab(2)}
                        >
                            <i className="uil uil-briefcase-alt qualification__icon"></i> Experience
                        </div>
                    )}
                </div>

                <div className="qualification__sections">
                    {toggleState === 1 && (
                        <div className="qualification__content qualification__content-active">
                            {renderTimeline(educations)}
                        </div>
                    )}

                    {toggleState === 2 && (
                        <div className="qualification__content qualification__content-active">
                            {renderTimeline(experiences)}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Qualification;
